import { Blog } from 'entities/blog'
import { User, UserType } from 'entities/user'

export function canSee(
    blog: Pick<Blog, 'published' | 'creatorId'>,
    user: Pick<User, 'id' | 'type'> | null,
) {
    return blog.published || blog.creatorId === user?.id || user?.type === UserType.Admin
}

export function canEdit(
    blog: Pick<Blog, 'creatorId'>,
    user: Pick<User, 'id' | 'type'> | null,
) {
    return user?.type === UserType.Admin || user?.id === blog.creatorId
}
